module.exports = __webpack_public_path__ + "static/media/Sopalechuga.c3ae6d9f.jpg";